import React from 'react';
import SignPortal from '../features/signing/SignPortal.jsx';
import { tokenFromPath } from '../features/signing/SignPortal.rules.js';

/**
 * SignPortalPage — PUBLIC page at /sign/<token>: the pickup / delivery / freight receipt a
 * customer or driver signs on their own phone after scanning the QR (jobq-api /portal/sign/*).
 *
 * Rendered by App() BEFORE the providers, like the other portals: no site login, no nav, no AI
 * drawer, no service worker (serviceWorkerRegistration.js NO_WORKER_PREFIXES). The token in the
 * URL is the only credential.
 */
export default function SignPortalPage() {
  const token = tokenFromPath(typeof window !== 'undefined' ? window.location.pathname : '');
  return <SignPortal token={token} />;
}
